module.exports = {
  logo: {
    lastUpdate: 'vom {{ts}}'
  },
  nav: {
    collapseToggle: {
      collapsed: 'Ausklappen',
      expanded: 'Einklappen',
    },
    byPath: {
      // WEBSITE
      '/tarantula/website': 'Website',
      '/tarantula/website/seitenbaum': 'Seitenbaum',
      '/tarantula/website/master-components': 'Vorlagen',
      '/tarantula/website/bildverwaltung': 'Bildverwaltung',
      '/tarantula/website/dateiverwaltung': 'Dateiverwaltung',
      '/tarantula/website/bildverwaltungartbildarchiv': 'Download - Stats',
      '/tarantula/website/artads': 'Banner',
      '/tarantula/website/livecom-members': 'Mitglieder',
      '/tarantula/website/livecom-jobs': 'Jobs',
      '/tarantula/website/ninja-modules/events': 'Events',
      '/tarantula/website/ninja-modules/news': 'News',
      '/tarantula/website/ninja-modules/customers': 'Kunden',
      '/tarantula/website/layouts': 'Layouts',
      '/tarantula/website/components': 'Komponenten',
      '/tarantula/website/atoms': 'Atoms',
      '/tarantula/website/categories': 'Kategorien',
      '/tarantula/website/tag-scopes': 'TagScopes',
      '/tarantula/website/validators': 'Validatoren',

      // NEWSLETTER
      '/tarantula/newsletter': 'Newsletter',
      '/tarantula/newsletter/mailings': 'Aussendungen',
      '/tarantula/newsletter/newsletter': 'Newsletter',
      '/tarantula/newsletter/mailinglists': 'Mailinglisten',
      '/tarantula/newsletter/subscribers': 'Empfänger',
      '/tarantula/newsletter/segments': 'Segmente',

      // GLOBALS
      '/tarantula/globals': 'Globals',
      '/tarantula/globals/mailings': 'Aussendungen',
      '/tarantula/globals/smsstats': 'SMS-Stats',
      '/tarantula/globals/usersessions': 'Sessions',

      // ART CRM
      '/tarantula/art-crm': 'ART-CRM',
      '/tarantula/art-crm/addresses': 'Adressen',
      '/tarantula/art-crm/trips': 'Reisen',
      '/tarantula/art-crm/activities': 'Arbeiten',
      '/tarantula/art-crm/cooperations': 'Kooperationen',

      // ART FORM
      '/tarantula/art-form': 'ART-FORM',
      '/tarantula/art-form/addresses': 'Adressen',
      '/tarantula/art-form-competition': 'Gewinnspiel',
      '/tarantula/art-form-competition/addresses': 'Adressen',
      '/tarantula/art-form-magazineorder': 'Bestellungen',
      '/tarantula/art-form-magazineorder/addresses': 'Adressen',

      // TTG SHOP
      '/tarantula/ttg-shop': 'Shop',
      '/tarantula/ttg-shop/products': 'Produkte',
      '/tarantula/ttg-shop/coupons': 'Gutscheine',
      '/tarantula/ttg-shop/orders': 'Bestellungen',
      '/tarantula/ttg-shop/users': 'Benutzer',

      // MBLX
      '/tarantula/mblx': 'PDS',
      '/tarantula/mblx/products': 'Produkte',
      '/tarantula/mblx/products-additional-information': 'KI-Texte',
      '/tarantula/mblx/prompts': 'Prompts',
      '/tarantula/mblx/reports': 'Berichte',

      // PROTOCOL
      '/tarantula/protocol': 'Historie',
      '/tarantula/protocol/protocol': 'Protokoll',
      '/tarantula/protocol/stats': 'Statistik',

      // TARANTULA
      '/tarantula/tarantula': 'Tarantula',
      '/tarantula/tarantula/clients': 'Klienten',
      '/tarantula/tarantula/services': 'Services',
      '/tarantula/tarantula/service-users': 'ServiceUsers',
      '/tarantula/tarantula/scopes': 'Scopes',
      '/tarantula/tarantula/users': 'Benutzer',
      '/tarantula/tarantula/privileges': 'Privilegien',

      // USER MANAGEMENT
      '/tarantula/users': 'Users',
      '/tarantula/users/scopes': 'Scopes',
      '/tarantula/users/users': 'Benutzer',
      '/tarantula/users/privileges': 'Privilegien',

      // LANGUAGE SELECTOR
      '/tarantula/languageselector': 'Sprachen',

      // USER PROFILE
      '/tarantula/userprofile': 'Anonymous', // will be used as fallback if the user has no name, code or email
      '/tarantula/userprofile/settings': 'Einstellungen',
      '/tarantula/userprofile/signout': 'Abmelden',

      // COMMON
      '/tarantula/signout': 'Abmelden',
    },
  },
  hint: {
    delete: {
      really: {
        banner: {
          title: 'Sicher?',
          message: 'Sind Sie sich sicher, dass Sie diesen Banner irreversibel löschen möchten?',
        },
        component: {
          title: 'Sicher?',
          message: 'Sind Sie sich sicher, dass Sie diese Komponente irreversibel löschen möchten?',
        },
        route: {
          title: 'Sicher?',
          message: 'Sind Sie sich sicher, dass Sie diese Seite irreversibel löschen möchten?',
        },
        layout: {
          title: 'Sicher?',
          message: 'Sind Sie sich sicher, dass Sie dieses Layout irreversibel löschen möchten?',
        },
        section: {
          title: 'Sicher?',
          message: 'Sind Sie sich sicher, dass Sie diese Sektion irreversibel löschen möchten?',
        },
        atom: {
          title: 'Sicher?',
          message: 'Sind Sie sich sicher, dass Sie dieses Atom irreversibel löschen möchten?',
        },
        templateAtom: {
          title: 'Sicher?',
          message: 'Sind Sie sich sicher, dass Sie dieses Template-Atom irreversibel löschen möchten?',
        },
        privilege: {
          title: 'Sicher?',
          message: 'Sind Sie sich sicher, dass Sie dieses Privileg irreversibel löschen möchten?',
        },
        user: {
          title: 'Sicher?',
          message: 'Sind Sie sich sicher, dass Sie diesen Benutzer irreversibel löschen möchten?',
        },
        serviceUser: {
          title: 'Sicher?',
          message: 'Sind Sie sich sicher, dass Sie diesen Service-Benutzer irreversibel löschen möchten?',
        },
        assignedService: {
          title: 'Sicher?',
          message: 'Sind Sie sich sicher, dass Sie diese Service-Zuordnung irreversibel löschen möchten?',
        },
        scope: {
          title: 'Sicher?',
          message: 'Sind Sie sich sicher, dass Sie diesen Scope irreversibel löschen möchten?',
        },
        scopeRole: {
          title: 'Sicher?',
          message: 'Sind Sie sich sicher, dass Sie diese ScopeRolle irreversibel löschen möchten?',
        },
        client: {
          title: 'Sicher?',
          message: 'Sind Sie sich sicher, dass Sie diesen Klienten irreversibel löschen möchten?',
        },
        service: {
          title: 'Sicher?',
          message: 'Sind Sie sich sicher, dass Sie diesen Service irreversibel löschen möchten?',
        },
        validator: {
          title: 'Sicher?',
          message: 'Sind Sie sich sicher, dass Sie diesen Validator irreversibel löschen möchten?',
        },
        tagScope: {
          title: 'Sicher?',
          message: 'Sind Sie sich sicher, dass Sie den gewählten TagScope irreversibel löschen möchten?',
        },
        newsletter: {
          title: 'Sicher?',
          message: 'Wollen Sie diesen Newsletter wirklich löschen?',
        },
        mailing: {
          title: 'Sicher?',
          message: 'Wollen Sie diese Aussendung wirklich irreversibel löschen?',
          subscriber: {
            title: 'Sicher?',
            message: 'Wollen Sie diese Empfänger-Zuordnung wirklich irreversibel löschen?',
          },
        },
        subscriber: {
          title: 'Sicher?',
          message: 'Wollen Sie diesen Empfänger wirklich irreversibel löschen?',
        },
        segment: {
          title: 'Sicher?',
          message: 'Wollen Sie dieses Segment wirklich irreversibel löschen?',
        },
        address: {
          title: 'Sicher?',
          message: 'Wollen Sie diese Adresse wirklich irreversibel löschen?\n\nBitte bedenken Sie, dass dieser Vorgang auch alle der Adresse zugeordneten Daten wie Reisen, Arbeiten und Verbindungen betrifft.',
        },
        contact: {
          title: 'Sicher?',
          message: 'Wollen Sie diesen Kontakt wirklich irreversibel löschen?',
        },
        trip: {
          title: 'Sicher?',
          message: 'Sind Sie sicher, dass Sie diese Reise irreversibel löschen wollen?',
        },
        cooperation: {
          title: 'Sicher?',
          message: 'Sind Sie sicher, dass Sie diese Kooperation irreversibel löschen wollen?',
        },
        addressConnection: {
          title: 'Sicher?',
          message: 'Wollen Sie diese Verbindung wirklich irreversibel löschen?',
        },
        artFormAddress: {
          title: 'Sicher?',
          message: 'Wollen Sie diese Adresse wirklich irreversibel löschen?',
        },
        artFormAddresses: {
          title: 'Sicher?',
          message: 'Sind Sie sicher, dass Sie {{nrOfMatchingElements}} Addressen irreversibel löschen wollen?',
        },
        mblx: {
          product: {
            title: 'Sicher?',
            message: 'Sind Sie sicher, dass Sie dieses Produkt irreversibel löschen wollen?',
          },
          prompt: {
            title: 'Sicher?',
            message: 'Sind Sie sicher, dass Sie diesen Prompt irreversibel löschen wollen?',
          },
        },
        jobs: {
          title: 'Sicher?',
          message: 'Sind Sie sicher, dass Sie diesen Job und alle zugeordneten Daten irreversibel löschen wollen?',
        },
        members: {
          title: 'Sicher?',
          message: 'Sind Sie sicher, dass Sie dieses Mitglied und alle zugeordneten Daten irreversibel löschen wollen?',
        },
      },
    },
    setProcessed: {
      really: {
        artFormAddresses: {
          title: 'Sicher?',
          message: 'Sind Sie sicher, dass Sie {{nrOfMatchingElements}} Adressen als abgearbeitet markieren wollen?',
        },
      },
    },
    artForm: {
      address: {
        export: {
          limit: {
            title: 'Sicher?',
            message: 'Im Moment würden {{nrOfMatchingElements}} Adressen exportiert werden. Aus technischen Gründen wird der Export aber auf {{max}} Adressen limitiert. Wollen Sie dennoch fortfahren?',
          },
        },
      },
    },
    artCrm: {
      address: {
        export: {
          addresses: {
            limit: {
              title: 'Sicher?',
              message: 'Im Moment würden {{nrOfMatchingElements}} Adressen exportiert werden. Aus technischen Gründen wird der Export aber auf {{max}} Adressen limitiert. Wollen Sie dennoch fortfahren?',
            },
          },
          newsletter: {
            limit: {
              title: 'Sicher?',
              message: 'Im Moment würden die Newsletter Emails von {{nrOfMatchingElements}} Adressen exportiert werden. Aus technischen Gründen wird der Export aber auf {{max}} Adressen limitiert. Wollen Sie dennoch fortfahren?',
            },
          },
        },
      },
    },
    newsletter: {
      subscriber: {
        reactivate: {
          title: 'Sicher?',
          message: 'Der Empfänger mit dieser Email-Adresse hat sich von dieser Mailingliste abgemeldet. Sind Sie sicher, dass Sie ihn reaktivieren möchten?',
        },
        export: {
          limit: {
            title: 'Sicher?',
            message: 'Im Moment würden {{nrOfMatchingElements}} Empfänger exportiert werden. Aus technischen Gründen wird der Export aber auf {{max}} Empfänger limitiert. Wollen Sie dennoch fortfahren?',
          },
        },
      },
    },
    mblx: {
      product: {
        export: {
          limit: {
            title: 'Sicher?',
            message: 'Im Moment würden {{nrOfMatchingElements}} Artikel exportiert werden. Aus technischen Gründen wird der Export aber auf {{max}} Adressen limitiert. Wollen Sie dennoch fortfahren?',
          },
        },
      },
      requestProductAdditionalInformation: {
        softLimitReached: {
          title: 'Sicher?',
          message: 'Sie sind im Begriff {{nrOfMatchingElements}} KI-Texte anzufordern. Wollen Sie dennoch fortfahren?',
        },
        editStatusPimElementsFound: {
          title: 'Sicher?',
          message: 'Sie sind im Begriff für {{nrOfMatchingElements}} ins Pim kopierte Elemente KI-Texte anzufordern. Wollen Sie dennoch fortfahren?',
        },
      },
    },
  },
  contextMenu: {
    route: {
      showProperties: 'Eigenschaften',
      editContent: 'Inhalt bearbeiten',
      open: 'Route öffnen',
      duplicate: 'Route duplizieren',
      cut: 'Ausschneiden',
      paste: {
        all: 'Einfügen',
        before: 'Davor einfügen',
        within: 'Innerhalb einfügen',
        after: 'Danach einfügen',
      },
    },
  },
  status: {
    routeTrees: {
      // TODO: DEUTSCH? was ist damit gemeint?
      refreshTreesWhileDragging: 'Bitte versuchen Sie das via "Drag n Drop" nur Baum-Elemente auf der aktuell geladenen Seite zu verwenden. Sie können bei Bedarf auch "Ausschneiden / Einfügen" im Kontextmenü verwenden...',
    },
  },
  table: {
    head: {
      address: 'Adressen',
      contact: 'Kontakte',
      trip: 'Reisen',
      activity: 'Arbeiten',
      addressConnection: 'Verbindungen',
      mailing: 'Aussendungen',
      mailingUrl: 'Klicks',
      product: 'Produkte',
      order: 'Bestellungen',
      user: 'Benutzer',
      coupon: 'Gutscheine',
      selection: {
        product: 'Produkt - Auswahl',
      },
    },
  },
  form: {
    fields: {
      autoCompleteResourcePickerMulti: {
        nrOfChosenElements: '{{nrOfElements}} Einträge gewählt',
      },
    }
  },
  dataValues: {
    newsletter: {
      subscriber: {
        removeMassProperty: {
          1: 'Entfernen',
          0: 'Beibehalten',
        },
      },
    },
  },
  newsletter: {
    segmentsData: {
      groupHeads: {
        defaultFields: 'Standard-Felder',
        mailingListFields: 'Felder aus Mailingliste',
      },
      selectDefaultValues: {
        defaultFields: 'Feld wählen',
        defaultOperators: 'Operator wählen',
      },
      defaultFields: {
        firstName:  'Vorname',
        lastName:   'Nachname',
        email:      'Email-Adresse',
        createdAt:  'Datum der Anmeldung',
      },
      operators: {
        eq: 'entspricht (=)',
        ne: 'entspricht nicht (<>)',
        gt: 'größer als (>)',
        ge: 'größer gleich (>=)',
        lt: 'kleiner als (<)',
        le: 'kleiner gleich (<=)',
        lk: 'enthält',
        nl: 'enthält nicht',
        'lk-and': 'enthält Alle',
        'nl-and': 'enthält Keinen',
        'lk-or': 'enthält Einen',
        'nl-or': 'enthält Einen nicht',
      },
    },
    subscribers: {
      controller: {
        title: 'Empfänger',
      },
      import: {
        chooseType: {
          title: 'Import-Typ wählen',
          message: 'Bitte wählen Sie hier den Typ des Imports. Sie können entweder anhand der später hochgeladenen Liste Empfänger anlegen, oder diese Liste nur zur Identifikation von bereits existierenden Empfängern verwenden, um diesen Eigenschaften hinzuzufügen oder zu entfernen.',
        },
      },
    },
  },
  mailing: {
    controller: {
      title: 'Aussendungen',
    },
    summary: {
      nrOfElements: 'Sichtbare Aussendungen',
      nrOfMatchingElements: 'Gefilterte Aussendungen',
      nrOfAllElements: 'Alle Aussendungen',
    },
    stats: {
      info: {
        headline: 'Diagramm-Informationen',
      },
    },
    hint: {
      schedule: {
        sendDateTimeInPast: {
          title: 'Versand sofort starten?',
          message: 'Der Versandzeitpunkt befindet sich in der Vergangenheit! Möchten Sie den Versand sofort starten?',
        },
      },
    },
  },
  smsStats: {
    controller: {
      title: 'SMS-Statistik',
    },
  },
  mailingUrl: {
    controller: {
      title: 'Klicks',
    },
    summary: {
      nrOfElements: 'Sichtbare Urls',
      nrOfMatchingElements: 'Gefilterte Urls',
      nrOfAllElements: 'Alle Urls',
    },
  },
  product: {
    controller: {
      title: 'Produkte',
    },
    summary: {
      nrOfSelectedElements: 'Ausgewählte Produkte',
      nrOfElements: 'Sichtbare Produkte',
      nrOfMatchingElements: 'Gefilterte Produkte',
      nrOfAllElements: 'Alle Produkte',
    },
    form: {
      picker: {
        summary: '{{nrOfElements}} Produkte gewählt',
      },
    },
    states: {
      headline: 'Aktiv - Zeiträume',
    },
    prices: {
      headline: 'Preis - Staffeln',
    },
    manualPromptAssociations: {
      modalTitle: 'Welche Prompts sollen verwendet werden?',
      modalTooltipMessage: 'Bitte wählen Sie für jedes der angeführten Produkte eine Aktion bzw. einen Prompt.<br><br>Tipp: Der Knopf "Alle Prompt-Entscheidungen treffen" durchläuft die ganze Liste.',
      controller: {
        title: 'Prompt-Entscheidungen',
      },
      reRunMessage: {
        title: 'Hinweis',
        message: 'Bitte vervollständigen Sie die Prompt-Entscheidungen für die noch offenen {{nrOfElements}} Produkte.',
      },
      summary: {
        nrOfDecidedElements: 'Produkte mit Prompt-Entscheidung',
        nrOfUndecidedElements: 'Produkte ohne Prompt-Entscheidung',
        nrOfAllElements: 'Alle Produkte',
      },
      table: {
        fields: {
          decision: {
            ignore: 'Ignorieren',
            empty: 'Ohne Prompt',
            prompt: 'Mit Prompt',
            outstanding: 'Ausständig',
          }
        },
      },
      promptChooser: {
        modalTitle: 'Produkt-Prompt wählen',
        productDetails: {
          title: 'Produkt-Details',
          productID: 'ID',
          name: 'Name',
          number: 'Nummer',
        },
      },
    },
  },
  productAdditionalInformation: {
    controller: {
      title: 'KI-Texte',
    },
    summary: {
      nrOfSelectedElements: 'Ausgewählte KI-Texte',
      nrOfElements: 'Sichtbare KI-Texte',
      nrOfMatchingElements: 'Gefilterte KI-Texte',
      nrOfAllElements: 'Alle KI-Texte',
    },
    importerUploader: {
      success: 'Import erfolgreich abgeschlossen',
      nrOfInserts: '{{nrOfInserts}} Einträge angelegt',
      nrOfUpdates: '{{nrOfUpdates}} Einträge angepasst',
      duplicateNumbers: 'Die Mehrfach-Nennungen der folgenden {{nrOfDuplicateNumbers}} Produkt-Nummern wurde ignoriert: <span>{{duplicateNumbers}}</span>',
    },
    requestProductAdditionalInformation: {
      summary: '{{nrOfElements}} Produkt(e) wurde(n) überprüft,<br>{{nrOfElementsPrevented}} Produkt(e) wurde(n) ignoriert und<br>{{nrOfElementsRequested}} Produkt(e) wurde zum Generieren der KI-Texte eingereiht.',
    },
    table: {
      externalApiStatus: {
        transport: '{{ts}} | Transport',
        transportError: '{{ts}} | Fehler beim Transport',
        requestSuccess: '{{ts}} | Abgeliefert',
        requestError: '{{ts}} | Fehler beim Abliefern',
        notifySuccess: '{{ts}} | Generiert',
        notifyError: '{{ts}} | Fehler beim Generieren',
        notifyTimeout: '{{ts}} | Zeitüberschreitung beim Generieren',
      },
    },
    stats: {
      headline: 'KI-Status',
      externalApiStatus: {
        none: 'Kein ({{nrOfElements}})',
        error: 'Fehler ({{nrOfElements}})',
        transport: 'Transport ({{nrOfElements}})',
        transportError: 'Fehler beim Transport ({{nrOfElements}})',
        requestSuccess: 'Abgeliefert ({{nrOfElements}})',
        requestError: 'Fehler beim Abliefern ({{nrOfElements}})',
        notifySuccess: 'Generiert ({{nrOfElements}})',
        notifyError: 'Fehler beim Generieren ({{nrOfElements}})',
        notifyTimeout: 'Zeitüberschreitung beim Generieren ({{nrOfElements}})',
      },
    },
  },
  prompt: {
    controller: {
      title: 'Prompts',
    },
    summary: {
      nrOfElements: 'Sichtbare Prompts',
      nrOfMatchingElements: 'Gefilterte Prompts',
      nrOfAllElements: 'Alle Prompts',
    },
    showInsertModal: {
      title: 'Neuen Prompt anlegen',
    },
    showEditModal: {
      title: 'Prompt bearbeiten',
    },
    showSelectModal: {
      title: {
        single: 'Prompt wählen',
      },
    },
    form: {
      picker: {
        summary: '{{-nrOfElements}} Prompts gewählt',
      },
    },
    availabilitySummaryForm: {
      modalTitle: 'Prompt - Vorauswahl',
      modalTooltipMessage: 'Hier werden die Produkte in Gruppen zusammengefasst dargestellt. Jede Gruppe ist speziell in Bezug auf die Verfügbarkeit der jeweiligen Prompts.<br><br>Sie können hier für jede Gruppe wählen ob sie die Gruppe <br>- <b>Ignorieren</b>, also ganz aus diesem KI-Texte-Generieren-Auftrag weglassen<br>- <b>Ohne Prompt</b> generieren lassen<br>- <b>Automatisch</b> einen eindeutig verfügbaren Prompt verwenden, oder <br>- <b>Manuell</b> eine Aktion bzw. einen Prompt wählen möchten.',
      fields: {
        ignore: '{{nrOfElements}} Produkt(e) werden gerade generiert',
        none: '{{nrOfElements}} Produkt(e) ohne Prompt',
        single: '{{nrOfElements}} Produkt(e) mit eindeutigem Prompt',
        multiple: '{{nrOfElements}} Produkt(e) mit Prompt-Kollision',
      }
    }
  },
  order: {
    controller: {
      title: 'Bestellungen',
    },
    properties: {
      history: {
        title: 'Verlauf',
      },
      basket: {
        columns: {
          pos: 'POS',
          name: 'Name',
          img: 'Bild',
          qty: 'Menge',
          price: 'Preis',
          pos_sum: 'Summe',
          pos_vat: 'Steuer €',
          vat: 'Steuer %',
        },
        empty: 'Keine Positionen verfügbar',
      },
      address: {
        empty: 'Keine Addresse verfügbar',
      },
    },
    summary: {
      nrOfElements: 'Sichtbare Bestellungen',
      nrOfMatchingElements: 'Gefilterte Bestellungen',
      nrOfAllElements: 'Alle Bestellungen',
    },
  },
  coupon: {
    controller: {
      title: 'Gutscheine',
    },
    summary: {
      nrOfElements: 'Sichtbare Gutscheine',
      nrOfMatchingElements: 'Gefilterte Gutscheine',
      nrOfAllElements: 'Alle Gutscheine',
    },
  },
  user: {
    controller: {
      title: 'Benutzer',
    },
    summary: {
      nrOfElements: 'Sichtbare Benutzer',
      nrOfMatchingElements: 'Gefilterte Benutzer',
      nrOfAllElements: 'Alle Benutzer',
    },
  },
  subscriber: {
    controller: {
      title: 'Empfänger',
    },
    summary: {
      nrOfElements: 'Sichtbare Empfänger',
      nrOfMatchingElements: 'Gefilterte Empfänger',
      nrOfAllElements: 'Alle Empfänger',
    },
  },
  addresses: {
    controller: {
      title: 'Adressen',
    },
    export: {
      chooseType: {
        title: 'Export-Typ wählen',
        message: 'Wählen Sie bitte einen Export-Typ.\n\n* Bei Newsletter Exporten sind Verbindungen zur Sicherheit deaktiviert.',
      },
    },
    tabs: {
      new: {
        title: 'Neue Adresse',
      },
      title: {
        prefix: {
          default: 'Adresse',
          client: 'Kunde',
          journalist: 'Journalist',
          media: 'Media',
          contact: 'Kontakt',
        },
      },
    },
    form: {
      fields: {
        type: 'Typ / Rolle',
        street: 'Straße / Nr',
        zipCityCountry: 'PLZ / Ort / Land',
        tags: {
          headline: 'Kategorien',
        },
      },
      changeTypeHint: {
        title: 'Sicher?',
        message: 'Sind Sie sicher dass Sie den Adress-Typ verändern möchten?\n\nBitte beachten Sie, dass dies nicht nur diesen sondern auch andere Datensätze - wie zB.: die Reisen oder Arbeiten - betreffen kann!',
      },
    },
    contactList: {
      headline: 'Kontaktdetails',
      emptyRow: 'Keine Kontaktdetails verfügbar',
    },
    summary: {
      nrOfElements: 'Sichtbare Adressen',
      nrOfMatchingElements: 'Gefilterte Adressen',
      nrOfAllElements: 'Alle Adressen',
    },
  },
  trips: {
    controller: {
      title: 'Reisen',
    },
    tabs: {
      new: {
        title: 'Neue Reise',
      },
      title: {
        prefix: {
          default: 'Reise zu',
        },
      },
    },
    summary: {
      nrOfElements: 'Sichtbare Reisen',
      nrOfMatchingElements: 'Gefilterte Reisen',
      nrOfAllElements: 'Alle Reisen',
    },
  },
  activities: {
    controller: {
      title: 'Arbeiten',
    },
    tabs: {
      new: {
        title: 'Neue Arbeit',
      },
      title: {
        prefix: {
          default: 'Arbeiten von',
        },
      },
    },
    form: {
      fields: {
        details: 'Details',
      },
    },
    summary: {
      nrOfElements: 'Sichtbare Kunden',
      nrOfMatchingElements: 'Gefilterte Kunden',
      nrOfAllElements: 'Alle Kunden',
    },
  },
  cooperations: {
    controller: {
      title: 'Kooperationen',
    },
    tabs: {
      new: {
        title: 'Neue Kooperation',
      },
      title: {
        prefix: {
          default: 'Kooperation mit',
        },
      },
    },
    summary: {
      nrOfElements: 'Sichtbare Kooperationen',
      nrOfMatchingElements: 'Gefilterte Kooperationen',
      nrOfAllElements: 'Alle Kooperationen',
    },
  },
  routes: {
    form: {
      fields: {
        articleID: 'Artikel-Nummer / -Ausführung',
      },
    },
  },
  bulk: {
    summary: {
      nrOfElements: 'Sichtbare Komponenten',
      nrOfMatchingElements: 'Gefilterte Komponenten',
      nrOfAllElements: 'Alle Komponenten',
    },
  },
  protocol: {
    protocol: {
      controller: {
        title: 'Protokoll',
      },
      summary: {
        nrOfElements: 'Sichtbare Einträge',
        nrOfMatchingElements: 'Gefilterte Einträge',
        nrOfAllElements: 'Alle Einträge',
      },
      actionFormInfo: {
        rows: {
          methodTitle: 'Methode',
          entityID: 'ID',
          userTitle: 'Benutzer',
          loadingTS: 'Ladezeitpunkt',
          ts: 'Speicherzeitpunkt',
          entityTitle: 'Element',
        },
        methodDescription: {
          UPDATE_MOVE: 'Dieses Element wurde verschoben',
          route: {
            assignLayout: 'Dieser Route wurde ein Layout (#{{templateID}}) zugewiesen.',
          },
        },
      },
    },
    stats: {
      controller: {
        title: 'Statistik',
      },
      chartDescription: {
        nrOfActions: 'Hier sieht man die absolute Anzahl aller Aktionen.<br><br>Nachdem Inhalte fast immer auf mehrere Arten verwaltet werden können gilt für diesen Kennwert nicht automatisch, dass jemand fleißiger ist, weil mehr Aktionen aufgezeichnet wurden.<br><br>Um eine gute Lesbarkeit der Diagramme zu gewährleisten wird die Klassenbreite automatisch anhand des gewählten Betrachtungszeitraums festgelegt. Die Klassenbreite bestimmt wieviele Datensätze auf der Zeitachse zu einem Datenpunkt zusammengefasst werden.',
        nrOfActionsPart: 'Hier sieht man die Anzahl aller Aktionen eines Benutzers relativ zur Summe aller Aktionen in Prozent.<br><br>Nachdem Inhalte fast immer auf mehrere Arten verwaltet werden können gilt für diesen Kennwert nicht automatisch, dass jemand fleißiger ist, weil mehr Aktionen aufgezeichnet wurden.<br><br>Um eine gute Lesbarkeit der Diagramme zu gewährleisten wird die Klassenbreite automatisch anhand des gewählten Betrachtungszeitraums festgelegt. Die Klassenbreite bestimmt wieviele Datensätze auf der Zeitachse zu einem Datenpunkt zusammengefasst werden.',
        nrOfEntityUniqueActions: 'Hier sieht man die absolute Anzahl aller Objekte, die im Laufe einer Stunde manipuliert worden sind.<br><br>Mit Manipulation ist in diesem Kontext nicht nur das Bearbeiten, sondern auch das Löschen, Anlegen und Duplizieren gemeint.<br><br>Auch wenn die Klassenbreite des Diagramms eine einzelne Stunde übersteigen kann, werden die Objekt-Manipulationen pro Stunde gezählt. Wenn also jemand ein Objekt um 13:00 Uhr und um 14:00 Uhr bearbeitet wird es auch zwei mal gezählt.<br><br>Diese Kennzahl ist dazu gedacht den Fleiß von Benutzern besser vergleichen zu können. Es ist in der Regel nicht wichtig ob jemand mehrfach den selben Datensatz verändert, weil das Objekt maximal einmal pro Stunde gezählt wird unabhängig davon wie viele Aktionen aufgezeichnet wurden.<br><br>Um eine gute Lesbarkeit der Diagramme zu gewährleisten wird die Klassenbreite automatisch anhand des gewählten Betrachtungszeitraums festgelegt. Die Klassenbreite bestimmt wieviele Datensätze auf der Zeitachse zu einem Datenpunkt zusammengefasst werden.',
        nrOfEntityUniqueActionsPart: 'Hier sieht man die Anzahl aller Objekte, die im Laufe einer Stunde von einem Benutzer manipuliert worden sind in Relation zur Summe aller manipulierten Objekte eben dieser Stunde in Prozent.<br><br>Mit Manipulation ist in diesem Kontext nicht nur das Bearbeiten, sondern auch das Löschen, Anlegen und Duplizieren gemeint.<br><br>Auch wenn die Klassenbreite des Diagramms eine einzelne Stunde übersteigen kann, werden die Objekt-Manipulationen pro Stunde gezählt. Wenn also jemand ein Objekt um 13:00 Uhr und um 14:00 Uhr bearbeitet wird es auch zwei mal gezählt.<br><br>Diese Kennzahl ist dazu gedacht den Fleiß von Benutzern besser vergleichen zu können. Es ist in der Regel nicht wichtig ob jemand mehrfach den selben Datensatz verändert, weil das Objekt maximal einmal pro Stunde gezählt wird unabhängig davon wie viele Aktionen aufgezeichnet wurden.<br><br>Um eine gute Lesbarkeit der Diagramme zu gewährleisten wird die Klassenbreite automatisch anhand des gewählten Betrachtungszeitraums festgelegt. Die Klassenbreite bestimmt wieviele Datensätze auf der Zeitachse zu einem Datenpunkt zusammengefasst werden.',
        methodStats: 'Hier sieht man die Anzahl aller Aktionen pro aufgezeichneter Methode.',
      },
    },
  },
  tooltip: {
    routeComponentTree: {
      massInsert: {
        title: 'Schon gewusst?',
        message: 'Wenn Sie mehrere Komponenten auf einmal anlegen möchten können Sie Ihre Wunsch-Komponente mit gedrückter Strg-Taste anklicken um gleich danach noch weitere Komponenten anzulegen.<br><br>Die Komponenten werden dann ohne Inhalte nacheinander an die gewünschte Position eingefügt und können danach editiert werden.',
      },
      massImport: {
        title: 'Schon gewusst?',
        message: 'Wenn Sie mehrere Komponenten auf einmal anlegen möchten können Sie Ihre Wunsch-Komponente mit gedrückter Strg-Taste anklicken um gleich danach noch weitere Komponenten zu importieren.',
      },
    },
  },
  components: {
    interface: {
      importDone: {
        title: 'Import erfolgreich',
        message: 'Es wurden {{nrOfAddedComponents}} Components und {{nrOfAddedAtoms}} Atoms angelegt.',
      },
    },
  },
  categories: {
    interface: {
      importDone: {
        title: 'Import erfolgreich',
        message: 'Es wurden {{nrOfAddedCategories}} Categories und {{nrOfAddedCategoryDatas}} CategoryDatas angelegt.',
      },
    },
  },
  news: {
    controller: {
      title: 'News',
    },
    summary: {
      nrOfElements: 'Sichtbare News',
      nrOfMatchingElements: 'Gefilterte News',
      nrOfAllElements: 'Alle News',
    },
  },
  userSessions: {
    controller: {
      title: 'Sessions',
    },
    summary: {
      nrOfElements: 'Sichtbare Sessions',
      nrOfMatchingElements: 'Gefilterte Sessions',
      nrOfAllElements: 'Alle Sessions',
    },
  },
  ninja: {
    gatekeepers: {
      componentInstance: {
        addMissing: {
          message: 'Es ist noch keine Komponente \"{{entityCodeName}}\" vom Typ \"{{ninjaCodeName}}\" angelegt worden.<br><br>Wenn Sie möchten können Sie das mit diesem Knopf jetzt tun.',
        },
      },
      route: {
        addMissing: {
          message: 'Es ist noch keine Route angelegt worden.<br><br>Wenn Sie möchten können Sie das mit diesem Knopf jetzt tun.',
        },
      },
      entityPart: {
        addMissing: {
          message: 'Es wurden noch keine Sprachspezifischen Eigenschaften angelegt.<br><br>Wenn Sie möchten können Sie das mit diesem Knopf jetzt tun.',
        },
      },
    },
    filters: {
      fields: {
        showSelectionOnly: {
          label: 'Nur Auswahl',
          description: 'Soll die Liste der Einträge auf die getroffene Auswahl eingeschränkt werden?',
          info: '',
        },
      },
    },
    picker: {
      noticeDirty: 'Änderungen in diesem Feld werden erst nach dem Speichern wirksam',
    },
  },
  ninjaModules: {
    _common: {
      entityPart: {
        route: {
          properties: {
            tab: {
              title: 'Route',
              subTitle: 'Routen-Eigenschaften',
            },
          },
        },
        routeContent: {
          properties: {
            tab: {
              title: 'Inhalte',
              subTitle: 'Routen-Inhalte',
            },
          },
        },
      },
    },
    missingNinjaModule: {
      summary: {
        nrOfSelectedElements: 'Gewählte Elemente',
        nrOfElements: 'Sichtbare Elemente',
        nrOfMatchingElements: 'Gefilterte Elemente',
        nrOfAllElements: 'Alle Elemente',
      },
    },
    events: {
      hint: {
        delete: {
          really: {
            title: 'Sicher?',
            message: 'Sind Sie sicher, dass Sie dieses Event und alle zugeordneten Daten irreversibel löschen wollen?',
          },
        },
      },
      controller: {
        title: 'Events',
      },
      summary: {
        nrOfSelectedElements: 'Gewählte Events',
        nrOfElements: 'Sichtbare Events',
        nrOfMatchingElements: 'Gefilterte Events',
        nrOfAllElements: 'Alle Events',
      },
      showInsertModal: {
        title: 'Event anlegen',
      },
      entity: {
        properties: {
          headlines: {
            registrationOptions: 'Optionen',
            additionalData: 'Teilnehmer-Felder',
            internalData: 'Interne Teilnehmer-Felder',
          },
          tab: {
            title: "Event",
            subTitle: "Event-Eigenschaften",
          },
        },
        additionalInformation: {
          tab: {
            title: "Zusatz",
            subTitle: "Informationen zum Event",
          },
        },
        participants: {
          tab: {
            title: 'Teilnehmer',
            subTitle: 'Teilnehmerliste',
          },
        },
      },
      entityPart: {
        properties: {
          tab: {
            title: "Event",
            subTitle: "Sprachspezifische Eigenschaften",
          },
        },
        additionalInformation: {
          tab: {
            title: "Zusatz",
            subTitle: "Informationen zum Event",
          },
        },
      },
      participants: {
        controller: {
          title: 'Teilnehmer',
        },
        summary: {
          nrOfElements: 'Sichtbare Teilnehmer',
          nrOfMatchingElements: 'Gefilterte Teilnehmer',
          nrOfAllElements: 'Alle Teilnehmer',
        },
        export: {
          title: 'Event-Teilnehmer',
        },
      },
    },
    news: {
      hint: {
        delete: {
          really: {
            title: 'Sicher?',
            message: 'Sind Sie sicher, dass Sie diesen News-Beitrag und alle zugeordneten Daten irreversibel löschen wollen?',
          },
        },
      },
      controller: {
        title: 'News',
      },
      summary: {
        nrOfSelectedElements: 'Gewählte News',
        nrOfElements: 'Sichtbare News',
        nrOfMatchingElements: 'Gefilterte News',
        nrOfAllElements: 'Alle News',
      },
      showInsertModal: {
        title: 'News-Bericht anlegen',
      },
      entity: {
        properties: {
          tab: {
            title: "News",
            subTitle: "News-Eigenschaften",
          },
        },
      },
      entityPart: {
        properties: {
          tab: {
            title: "News",
            subTitle: "Sprachspezifische Eigenschaften",
          },
        },
        additionalInformation: {
          tab: {
            title: "Zusatz",
            subTitle: "Informationen zum News-Beitrag",
          },
        },
      },
    },
    customers: {
      hint: {
        delete: {
          really: {
            title: 'Sicher?',
            message: 'Sind Sie sicher, dass Sie diesen Kunden und alle zugeordneten Daten irreversibel löschen wollen?',
          },
        },
      },
      controller: {
        title: 'Kunden',
      },
      summary: {
        nrOfSelectedElements: 'Gewählte Kunden',
        nrOfElements: 'Sichtbare Kunden',
        nrOfMatchingElements: 'Gefilterte Kunden',
        nrOfAllElements: 'Alle Kunden',
      },
      showInsertModal: {
        title: 'Kunde anlegen',
      },
      picker: {
        summary: {
          empty: 'Kein Kunde gewählt',
          selected: {
            single: 'Ein Kunde gewählt',
            multi: '{{nrOfElements}} Kunden gewählt',
          },
        },
        buttons: {
          assign: {
            single: 'Kunde zuweisen',
            multi: 'Kunde(n) zuweisen',
            selected: 'Kunde(n) zuweisen (Auswahl)',
          },
          reset: 'Kunden - Zuweisung zurücksetzen',
          empty: 'Kunden - Zuweisung leeren',
        },
      },
      showSelectModal: {
        title: 'Kunde wählen',
      },
      entity: {
        properties: {
          tab: {
            title: "Kunde",
            subTitle: "Kunden-Eigenschaften",
          },
        },
      },
      entityPart: {
        properties: {
          tab: {
            title: "Kunde",
            subTitle: "Sprachspezifische Eigenschaften",
          },
        },
      },
    },
  },
  modal: {
    productAdditionalInformation: {
      importerUploader: {
        title: 'KI-Texte hochladen',
      },
      propertiesForm: {
        title: 'KI-Texte',
      },
    },
  },
  livecom_members: {
    controller: {
      title: 'Mitglieder',
    },
    showInsertModal: {
      title: 'Neues Mitglied anlegen',
    },
    showEditModal: {
      title: 'Mitglied bearbeiten',
    },
    summary: {
      nrOfElements: 'Sichtbare Mitglieder',
      nrOfMatchingElements: 'Gefilterte Mitglieder',
      nrOfAllElements: 'Alle Mitglieder',
    },
  },
  livecom_jobs: {
    controller: {
      title: 'Jobs',
    },
    showInsertModal: {
      title: 'Neuen Job anlegen',
    },
    showEditModal: {
      title: 'Job bearbeiten',
    },
    summary: {
      nrOfElements: 'Sichtbare Jobs',
      nrOfMatchingElements: 'Gefilterte Jobs',
      nrOfAllElements: 'Alle Jobs',
    },
  },
  artcrm_addresses: {
    showSelectModal: {
      title: 'Adresse wählen',
      byFilter: {
        title: 'Adressen wählen',
        button: 'Gefilterte Adressen importieren',
      },
    },
  },
}
